export default function useHomeLinkMode() {
	const homeLink =
		process.env.ENVIRONMENT === 'PDN'
			? process.env.SITE_PDN + '/'
			: process.env.ENVIRONMENT === 'STG'
				? process.env.SITE_STG + '/'
				: process.env.SITE_DEV + '/'

	const blogSiteAR = process.env.BLOG_SITE_AR + '/'
	return { homeLink, blogSiteAR }
}
